import Cookies from 'js-cookie';
import { region } from '../localizations/current-locale';
import hash from '../store/actions/api/application/hashFunction';
import { sendEvent } from './gtm';

export const defaultCookieOptions = {
  expires: 30,
};

export const hasConsent = () => {
  if (typeof window === 'undefined' || !window.Cookiebot) return false;
  const { consent } = window.Cookiebot;
  return (
    consent?.preferences
    || false
  );
};

const getDatalayerValueByKey = (key) => {
  let result = null;
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(function getDataLayerValue() {
      const value = this.get(key);
      if (value) {
        result = value;
      }
    });
  }
  return result || 0;
};

const hashValueIfNeeded = (state) => {
  if (!state || !state.latestFieldChanged) return null;

  const pathParts = state.latestFieldChanged.split('.');
  let value = state[pathParts[0]];
  if (pathParts.length > 1) {
    value = value[pathParts[1]];
  }

  if (
    state.latestFieldChanged === 'applicant.email'
    || state.latestFieldChanged === 'applicant.nationalID'
    || state.latestFieldChanged === 'applicant.phoneNumber'
    || state.latestFieldChanged === 'coApplicant.email'
    || state.latestFieldChanged === 'coApplicant.nationalID'
    || state.latestFieldChanged === 'coApplicant.phoneNumber'
  ) {
    return hash(value);
  }

  return value;
};

export const saveState = (name, state, options) => {
  if (sessionStorage.getItem('email') !== 'null') {
    sessionStorage.setItem('email', state.applicant.email);
  }
  if (sessionStorage.getItem('phoneNumber') !== 'null') {
    sessionStorage.setItem('phoneNumber', state.applicant.phoneNumber);
  }

  const newState = {
    ...state,
    bankAccount: null,
    applicant: {
      ...state.applicant,
      nationalId: null,
      phoneNumber: null,
      email: null,
    },
    coApplicant: {
      ...state.coApplicant,
      nationalId: null,
      phoneNumber: null,
      email: null,
    },
  };

  if (hasConsent()) {
    Cookies.set(name, JSON.stringify(newState), {
      ...defaultCookieOptions,
      ...options,
    });
  }

  if (typeof window !== 'undefined') {
    window.addEventListener('CookiebotOnAccept', () => {
      if (hasConsent()) {
        Cookies.set(name, JSON.stringify(newState), {
          ...defaultCookieOptions,
          ...options,
        });
      }
    });
  }

  sendEvent({
    event: 'Edit Form',
    edit_value: hashValueIfNeeded(state),
    eventCategory: `${region} PrivateLoan`,
    eventAction: 'Input',
    eventLabel: state.latestFieldChanged,
    currentSlide: getDatalayerValueByKey('currentSlide'),
    formType: getDatalayerValueByKey('formType') || 'mergeLoan',
  });
};

export const loadState = (name, options) => {
  try {
    const serializedState = Cookies.get(name, options);
    if (!serializedState) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch {
    return undefined;
  }
};

export const clearState = (name, options) => {
  Cookies.remove(name, options);
};
